<template>
  <div>
    查询表格
  </div>
</template>

<script>
	export default {
		name: "TableList"
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/list/TableList.vue